import * as React from 'react';
import { Button } from 'react-bootstrap';
import ICoordinate from './ICoordinate';
import Marker from './shapes/Marker';
import Polygon from './shapes/Polygon';
import Circle from './shapes/Circle';
import MapService from './MapService';

interface IMap {
    preventRerendering?: boolean;
    center: ICoordinate;
    highlightPhotographer?: number;
    settings?: IMapSettings[];
    zoom?: number;
    dontReRender?: boolean;
    mapId?: string;
    areaSelected?(entityId: number): void;
}

interface IMapSettings {
    center?: ICoordinate;
    marker?: Marker;
    polygon?: Polygon;
    circle?: Circle;
    entityId?: number;
}

export class Map extends React.Component<IMap, any> {
    private map: google.maps.Map = null;
    private zoom: number = 9;
    private mounted: boolean = false;

    private mapDivId: string = 'photographer-work-areas-google-map-' + Math.random();

    constructor(props: IMap) {
        super(props);

        this.getMap = this.getMap.bind(this);
    }

    // credit to http://stackoverflow.com/a/9653082
    censor(censor) {
        let i = 0;
        return (key, value) => {
            if (
                i !== 0 &&
                typeof censor === 'object' &&
                typeof value === 'object' &&
                censor === value
            )
                return '[Circular]';
            if (i >= 29) return '[Unknown]';
            ++i;
            return value;
        };
    }

    shouldComponentUpdate(nextProps: IMap, nextState: any) {
        if (this.props.dontReRender === true && this.mounted === true) {
            return false;
        }

        if (this.props.preventRerendering && this.props.settings) {
            return (
                JSON.stringify(nextProps.settings, this.censor(nextProps.settings)) !==
                    JSON.stringify(this.props.settings, this.censor(this.props.settings)) ||
                nextProps.highlightPhotographer !== this.props.highlightPhotographer ||
                JSON.stringify(nextProps.center) !== JSON.stringify(this.props.center)
            );
        }
        return true;
    }

    componentDidUpdate() {
        let ref = document.getElementById(this.mapDivId);
        this.initMap(ref);
    }

    componentDidMount() {
        if (this.props.mapId) {
            this.mapDivId = this.props.mapId;
        }

        let ref = document.getElementById(this.mapDivId);
        this.initMap(ref);
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps.mapId) {
            this.mapDivId = nextProps;
        }
    }

    initMap(ref: any) {
        if (ref !== null && this.props.settings) {
            if (!this.props.center) {
                MapService.getCurrentLocationCoordinate().then((coordinate: ICoordinate) => {
                    this.map = this.getMap(ref, coordinate);
                });
            } else {
                this.map = this.getMap(ref, this.props.center);
            }
        } else if (this.map !== null) {
            for (let setting of this.props.settings) {
                setting.polygon.redraw(this.map);
                setting.marker.redraw(this.map);
                setting.circle.redraw(this.map);
            }
        }
    }

    getMap(ref, center: ICoordinate): google.maps.Map {
        let map = new google.maps.Map(ref, {
            center: {
                lat: center.latitude,
                lng: center.longitude
            },
            streetViewControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoom: this.props.zoom ? this.props.zoom : this.zoom
        });

        map.addListener('zoom_changed', () => {
            this.zoom = map.getZoom();
        });

        if (this.props.settings) {
            for (let i = 0; i < this.props.settings.length; i++) {
                const setting = this.props.settings[i];

                if (setting.marker) {
                    setting.marker.createMarker(map);
                }
                if (setting.polygon) {
                    setting.polygon.createPolygon(
                        map,
                        this.props.highlightPhotographer &&
                            setting.entityId === this.props.highlightPhotographer,
                        () => this.props.areaSelected(setting.entityId)
                    );
                }
                if (setting.circle) {
                    setting.circle.createCircle(
                        map,
                        this.props.highlightPhotographer &&
                            setting.entityId === this.props.highlightPhotographer,
                        () => this.props.areaSelected(setting.entityId)
                    );
                }
            }
        }

        setTimeout(() => {
            this.mounted = true;
        }, 500);

        return map;
    }

    render() {
        return <div id={this.mapDivId} style={{ height: 500 + 'px', width: 100 + '%' }}></div>;
    }
}

export default Map;
